import "./polyfills";
import "./embed/EmbedController";
import "./config/axios";

require("./react/Root");
